import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Needs.css';

const Needs = () => {
  const [selectedCategory, setSelectedCategory] = useState('segments');
  const [animationTrigger, setAnimationTrigger] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setAnimationTrigger(true); // Trigger animation
    setTimeout(() => setAnimationTrigger(false), 1000); // Reset animation trigger
  };

  const renderContent = () => {
    switch (selectedCategory) {
      case 'segments':
        return (
          <div className={`needs-details ${animationTrigger ? 'needs-animate' : ''}`} data-aos="fade-right">
            <img
              src="/assets/images/segment.jpeg"
              alt="Segments"
            />
            <div className="needs-text">
              <ul>
                <li>Confectionery</li>
                <li>Agriculture and Horticulture</li>
                <li>Seed, Tissue Culture, Spices processing & Storage</li>
                <li>Food processing & Storage</li>
                <li>Ready to eat/Ready to Cook</li>
                <li>Dairy-Milk & Milk products</li>
                <li>Poultry & Meat processing</li>
                <li>Marine Processing</li>
                <li>Hospitality</li>
                <li>Central/ Commissaries/ Cloud/ Flight Kitchen</li>
                <li>Retail</li>
                <li>Healthcare</li>
                <li>Airport Cargo, 3PL Logistics</li>
                <li>Telecom and Data Center</li>
              </ul>
            </div>
          </div>
        );
      case 'applications':
        return (
          <div className={`needs-details ${animationTrigger ? 'needs-animate' : ''}`} data-aos="fade-left">
            <img
              src="/assets/images/applications.jpg"
              alt="Applications"
            />
            <div className="needs-text">
              <ul>
                <li>Cold Storage</li>
                <li>Blast Freezing</li>
                <li>Chilling Systems</li>
                <li>Processing Plants</li>
                <li>Refrigerated Transport</li>
                <li>Ripening Chambers</li>
                <li>Pre-cooling Units</li>
                <li>Warehousing Solutions</li>
              </ul>
            </div>
          </div>
        );
      case 'brands':
        return (
          <div className={`needs-details ${animationTrigger ? 'needs-animate' : ''}`} data-aos="fade-right">
            <img
              src="/assets/images/brand.jpg"
              alt="Brands"
            />
            <div className="needs-text">
              <ul>
                <li>Brand A</li>
                <li>Brand B</li>
                <li>Brand C</li>
                <li>Brand D</li>
                <li>Brand E</li>
                <li>Brand F</li>
              </ul>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <section className="needs">
      <div className="needs-content" data-aos="fade-up">
        <h2>Tell us your needs</h2>
        <p>
          Jaikon’s cold storage, processing, and engineering solutions have a range of industry sectors covered. From extending the shelf-life of vegetables to milk products to storing medicines to long-term storage of Brewery, our temperature-controlled, cutting edge cold technology solutions keep your products preserved in the best of conditions to delight your customers.
        </p>
        <div className="needs-categories">
          <button
            className={`needs-category ${selectedCategory === 'segments' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('segments')}
          >
            By Segments
          </button>
          <button
            className={`needs-category ${selectedCategory === 'applications' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('applications')}
          >
            By Applications
          </button>
          <button
            className={`needs-category ${selectedCategory === 'brands' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('brands')}
          >
            By Brands
          </button>
        </div>
        {renderContent()}
        <a href="#explore" className="needs-button" data-aos="fade-up">Explore more</a>
      </div>
    </section>
  );
};

export default Needs;
